'use client';
import { useJumboConfig } from 'themes/jumbo/@jumbo/components/JumboConfigProvider/hooks';
import { NavLink } from "react-router-dom";
/*import { Link as MuiLink } from '@mui/material';*/
function Link(props: any) {
  const { LinkComponent } = useJumboConfig();

  // return <MuiLink component={LinkComponent} {...props} />;
  return <NavLink {...props} />;
}

export { Link };
